import { RouteType } from "../../constants/RouteType";
import { AuthService } from "../auth/AuthService";


export class UploadFileService {

  static getImagePath = async (formDate: FormData) => {
    const url = RouteType.MASTER + RouteType.FILE;
    const response = AuthService.postCryptoRequest(url, formDate);
    return response;
  };

}